import styled from 'styled-components';

export const StyledVoiceSelectOption = styled.div`
  background: ${({ theme, $selected }) => $selected ? theme.buttonLightGreen : theme.buttonLightBlue};
  height: ${({ theme }) => theme.smallButtonSize};
  min-height: ${({ theme }) => theme.smallButtonSize};
  width: 100%;
  cursor: ${({ $selected }) => $selected ? 'default' : 'pointer'};
  text-transform: uppercase;
  font-family: "BebasNeue";
  font-size: 1.25rem;
  line-height: 1.25rem;
  font-weight: 700;
  color: black;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px;

  &:hover {
    background: ${({ theme, $selected }) => $selected ? theme.buttonLightGreen : 'white'};
  }
`;

